import dayjs from "dayjs";
import { Button, Flex } from "antd";

import StylesContainer from "./style";

import { isGrowthTypeRiskTolerance } from "../../../../../../../../utils/helper/specialized";
import { getCurrencyValueWithRoundSign } from "../../../../../../../../utils/helper/general";

const CardSavedProposal = ({ onClickViewProposal, proposalData }) => {
  const getLabelDetails = () => {
    // if (isGrowthTypeRiskTolerance(proposalData?.investmentObjective)) {
    return `${
      proposalData.calculated?.endingInvestmentBalance
        ? getCurrencyValueWithRoundSign(
            proposalData.calculated.endingInvestmentBalance
          )
        : "n/a"
    } over ${
      proposalData.lengthOfInvestment ?? proposalData.investmentDuration
    } yrs`;
    // } else if (proposalData?.calculated?.withdrawalAmount) {
    //   return getCurrencyValueWithRoundSign(
    //     proposalData.calculated.withdrawalAmount
    //   );
    // }
  };

  return (
    <StylesContainer gap={26} justify="space-between" wrap>
      <Flex gap={16}>
        <Flex gap={16} flex="1 0 204px" vertical>
          <Flex vertical>
            <span className="label">Client</span>
            <p className="value">
              {proposalData?.firstName} {proposalData?.lastName}
            </p>
          </Flex>
          <Flex vertical>
            <span className="label">Details</span>
            <p className="value">{getLabelDetails()}</p>
          </Flex>
        </Flex>

        <Flex gap={16} vertical>
          <Flex vertical>
            <span className="label">Saved</span>
            <p className="value">
              {proposalData?.updatedAt &&
                dayjs(proposalData.updatedAt).format("MMM D, YYYY")}
            </p>
          </Flex>
          <Flex vertical>
            <span className="label">Product</span>
            <p className="value">
              {proposalData?.financialProduct?.name ??
                proposalData?.financialProduct?.Name ??
                "Nothing selected"}
            </p>
          </Flex>
        </Flex>
      </Flex>

      <Button
        onClick={() => onClickViewProposal(proposalData?.email)}
        shape="round"
        size="small"
      >
        View Proposal
      </Button>
    </StylesContainer>
  );
};

export default CardSavedProposal;
